import navbar from './navbar';
import sidebar from './sidebar';

export default {
  navbar,
  sidebar,
};
